export const AdBreakType = {
  PRE: 'preroll',
  MID: 'midroll',
  POST: 'postroll',
  OVERLAY: 'overlay'
} as const;
